import styled, { css } from 'styled-components';
import { withoutProps } from '../../ui/utils';
import { screenSmMin, Text } from '@spotify-internal/encore-web';
import { TWO_COLUMN_MAX_WIDTH } from '../../ui';
const LARGE_BODY_TYPE = css `
  font-size: 1.5rem;
  line-height: 2rem;
`;
export const ResponsiveBodyType = styled(withoutProps(Text, 'noImage')).attrs({
    variant: 'bodyMedium',
}) `
  @media (min-width: ${screenSmMin}) {
    ${LARGE_BODY_TYPE}
  }

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${({ noImage }) => (noImage ? LARGE_BODY_TYPE : '')}
  }
`;
